import Callbacks from './callbacks';
import $ from 'jquery';

window.Callbacks = {
  IdeasOrganizations: {
    ProxyVotes: {
      selectOrganization:
        Callbacks.IdeasOrganizations.ProxyVotes.selectOrganization,
    },
  },
  Portals: {
    SelectroV2: {
      OrgFilter: {
        Select({ payload }) {
          const { value, text } = payload.item;
          const queryParams = new URLSearchParams(window.location.search);
          const filter = document.querySelector('.header-filter--organization');
          filter.classList.remove('open');
          queryParams.delete('page');
          if (!value) {
            queryParams.delete('organization');
            queryParams.delete('selectro_idea_organization_filter_id');
          } else {
            queryParams.set('organization', text);
            queryParams.set('selectro_idea_organization_filter_id', value);
          }
          window.location.href =
            window.location.pathname + '?' + queryParams.toString();
        },
      },
    },
  },
  Salesforce: {
    SearchForm: {
      selectionChanged: function () {
        $('#salesforce-form').salesforceIdeaSearchForm(
          'submitSearch',
          $('#ideas_idea_name').val()
        );
      },
    },
  },
};
